module.exports = __webpack_public_path__ + "img/图片11.7de71459.png";